const translations = {
  title: 'Enviando Formulário',
  subtitle: 'Preencha os campos a seguir para enviar o formulário',
  form: 'Formulário a enviar',
  placeField: 'Campo de email',
  'guide.title': 'Selecione os locais para enviar o formulário: ',
  'guide.title_person': 'Selecione as pessoas para enviar o formulário: ',
  'guide.fleet': 'Selecione as Frotas para enviar o formulário: ',
  'guide.help': 'Precisa de ajuda? Clique aqui para iniciar o tour',
  'tour.selectRow.title': 'Selecione o destinário',
  'tour.selectRow.message': 'Na página de locais, comece selecionando para quem deseja enviar o formulário.',
  'tour.selectRow.message_person': 'Na página de pessoas, comece selecionando para quem deseja enviar o formulário.',
  'tour.selectRow.message_fleet': 'Na página de pessoas, comece selecionando para quem deseja enviar o formulário.',
  'tour.selectRow.subMessage': '(Clique no checkbox para prosseguir)',
  'tour.sendForm.title': 'Clique em "Enviar Formulário"',
  'tour.sendForm.message': 'Quando finalizar a seleção, clique em Enviar Formulário no menu inferior',
  'tour.sendForm.subMessage': '(Clique no botão para prosseguir)',
  'tour.selectForm.title': 'Selecione qual formulário',
  'tour.selectForm.message': 'Preencha qual o formlulário a ser enviado',
  'tour.selectForm.subMessage': '',
  'tour.selectField.title': 'Selecione o campo de email',
  'tour.selectField.message': 'Preencha qual o campo de email a ser evniado.',
  'tour.selectField.subMessage':
    '(Caso não tenha um campo de email, é preciso configurar isso antes. Peça para o admin do sistema fazer isso.)',
  'tour.finish.title': 'Pronto! Isso é tudo!',
  'tour.finish.message':
    'Depois basta clicar no botão de enviar e todos selecionados irão receber um email com instruções de como iniciar.',
  'tour.finish.subMessage': '(Lembre-se que você pode usar os filtros no topo da tabla para facilitar a seleção)'
}

export default translations
